import React, { useContext, useEffect } from 'react';
import { Grid } from '@mui/material';
import EventCard from '../ui/EventCard';
import { Context } from '../../App';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/fr'; // Assurez-vous d'importer la locale française

const EventsSection = () => {
  const navigate = useNavigate()
    const {region} = useContext(Context)
    const [load, setLoad] = React.useState(true);
    const [projects, setProjects] = React.useState([]);

    useEffect(()=>{
        const query = new URLSearchParams({ region, type:'évènement', statut:'en cours' }).toString();

        fetch(process.env.REACT_APP_API_URL.concat('/public/projects?'+ query), {method: 'GET'})
        .then((res) => res.json())
        .then((data) => { 
            setProjects(data);
            setLoad(false);
        })
        .catch((err) => {
            console.error("Error fetching eglises:", err);
            setLoad(false);
        });
    }, [])

  const handleCardClick = (title) => {
    console.log(`Clicked on: ${title}`);
    // Ajouter ici la logique de navigation
  };

  return (
    <Grid container spacing={3} sx={{ mb: 6 }}>
      {projects.map((project, index) => (
        <Grid size={{sx: 12, sm:6, md:3}} minWidth={300} key={index}>
          <EventCard
            image={project.image}
            title={project.titre}
            description={'inscription du '+moment.utc(project.dateDebut).format('DD MMM yyyy')+' au '+moment.utc(project.dateFin).format('DD MMM yyyy')}
            onClick={() => navigate(`/billetterie/${project._id}`)}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default EventsSection;